import { Pressable } from '@rbilabs/universal-components';

export const HeaderLeftContainer = Pressable.withConfig({
  minHeight: '$12',
  minWidth: '$12',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: -4,
});
